exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.weather {\n  padding-top: 8px;\n  font-size: 1.2em;\n  text-align: right;\n}\n", "", {"version":3,"sources":["/Users/bencentra/Projects/MagounStatusBoardUI/src/components/src/components/weather.vue?23538d98"],"names":[],"mappings":";AAcA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;CACA","file":"weather.vue","sourcesContent":["<template>\n<div class=\"weather\">\n  <div v-if=\"data\"><strong>Weather: </strong>{{data.main.temp}}℉, {{data.weather[0].main}}</div>\n  <div v-else>No data available</div>\n</div>\n</template>\n\n<script>\nexport default {\n  props: ['data']\n}\n</script>\n\n<style>\n.weather {\n  padding-top: 8px;\n  font-size: 1.2em;\n  text-align: right;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b701e7a0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/weather.vue
// module id = 346
// module chunks = 0